<template>
    <div class="listings-list layout6">
        <Swiper v-bind="swiperOption" v-if="!isMobile" @progress="resetGrid">
            <Slide v-for="(item, index) in result.listings" :key="index">
                <house :house="item" />
            </Slide>
            <template v-if="showPlaceholder">
                <Slide
                    v-for="i in len"
                    class="house-placeholder"
                    :key="i"
                >
                    <li class="house-slider-item layout6">
                        <article>
                            <div class="house-imgs">
                                <site-img :src="picSrc" dir="64"></site-img>
                            </div>
                            <div class="house-info">
                                <div class="house-price-wrap"></div>
                                <div class="detail"></div>
                                <div class="address"></div>
                                <div class="mls-box"></div>
                            </div>
                        </article>
                    </li>
                </Slide>
            </template>
        </Swiper>
        <template v-else>
            <div class="item-box" v-for="(item, index) in result.listings" :key="index">
                <house :house="item" />
            </div>
        </template>
    </div>
</template>
<script>
import house from './house.vue';
import list from '../list.js';
import util from '@/common/util';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';

export default {
    computed: {
        swiperOption({ isMobile }) {
            let defaultSwiperOption = {
                slidesPerView: 'auto',
                loop: false,
                speed: 1000,
                initialSlide: 0,
                navigation: {
                    closest: '.md-house.layout6',
                    nextEl: '.house-next.layout6',
                    prevEl: '.house-prev.layout6',
                    disabledClass: 'house-swiper-disabled'
                }
            };
            if (isMobile) {
                return {};
            } else {
                return fixSwiperOptions(defaultSwiperOption);
            }
        },
        len() {
            // Less than 4 listings, number of default images
            let length = this.result.listings.length;
            if (window.innerWidth > 1000) {
                return 4 - length;
            } else {
                return 3 - length;
            }
        },
        showPlaceholder() {
            if (this.isMobile) {
                return; 
            }
            let length = this.result.listings.length;
            if (window.innerWidth > 1000) {
                return length < 4;
            } else {
                return length < 3;
            }
        }
    },
    components: {
        house,
        Swiper,
        Slide: SwiperSlide
    },
    mixins: [list],
    data() {
        return {
            picSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/md-house/layout6.png',
            fixGrid: util.throttle(function(swiper) {
                // 修正抽搐动画，400=卡片宽度350+边距50
                swiper.slidesSizesGrid = swiper.slidesSizesGrid.map(e => 400)
                swiper.slidesGrid = swiper.slidesGrid.map((e, index) => 400 * index)
                swiper.snapGrid = swiper.snapGrid.map((item, index) => 400 * index)
            }, 100)
        };
    },
    methods: {
        resetGrid(swiper) {
            this.fixGrid(swiper)
        }
    }
};
</script>
